import { render, staticRenderFns } from "./CaptionCard.vue?vue&type=template&id=77762326&scoped=true&"
import script from "./CaptionCard.vue?vue&type=script&lang=%20ts&"
export * from "./CaptionCard.vue?vue&type=script&lang=%20ts&"
import style0 from "./CaptionCard.vue?vue&type=style&index=0&id=77762326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77762326",
  null
  
)

export default component.exports